import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

import { AvatarComponent as Avatar } from '..'

/**
 * Container
 */
const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4px;
  width: 100%;
`

const Background = styled.div`
  align-items: center;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
`
/**
 * AvatarContainer
 */
const AvatarContainer = styled.div`
  margin: 8px;
`

/**
 * Title
 */
const Title = styled.p`
  color: rgb(62, 62, 62);
  font-family: TT, Helvetica, Arial, sans-serif;
  font-size: 22px;
  line-height: 26px;
  margin: 8px;
  padding: 0px;
  text-align: center;
`

const WebinarUserInfoPaneComponent = ({ name, children, avatarUrl }) => (
  <Container>
    <Background>
      {!!name && (
        <AvatarContainer>
          <Avatar imageSrc={avatarUrl} name={name} size={65} shape="square" />
        </AvatarContainer>
      )}
      <Title>
        {name ? (
          <FormattedMessage
            defaultMessage="Welcome {name}!"
            values={{ name }}
          />
        ) : (
          <FormattedMessage defaultMessage="Welcome!" />
        )}
      </Title>
      {children}
    </Background>
  </Container>
)

WebinarUserInfoPaneComponent.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  avatarUrl: PropTypes.string,
}

export default WebinarUserInfoPaneComponent
